var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg119Support(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "32px",
    height: "32px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e0",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3c-4.40644,0 -8,3.59356 -8,8v1c-1.1,0 -2,0.9 -2,2v2c0,1.1 0.9,2 2,2h2v-5v-1v-1c0,-3.32556 2.67444,-6 6,-6c3.32556,0 6,2.67444 6,6v1v1v5v1h-4.08789c-0.21163,-0.59859 -0.77721,-0.99911 -1.41211,-1c-0.82843,0 -1.5,0.67157 -1.5,1.5c0.00105,0.78597 0.60862,1.43785 1.39258,1.49414c0.03568,0.00388 0.07154,0.00583 0.10742,0.00586h5.5c1.09306,0 2,-0.90694 2,-2v-1c1.1,0 2,-0.9 2,-2v-2c0,-1.1 -0.9,-2 -2,-2v-1c0,-4.40644 -3.59356,-8 -8,-8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg119Support);
export default __webpack_public_path__ + "static/media/119 Support.e51359ce7c0fc4078210aa1e5191d211.svg";
export { ForwardRef as ReactComponent };